import { zustandLocalStorageName } from '../storeConstants'

export const readZustandLocalStorage = (path = '') => {
  const storedValue = localStorage.getItem(zustandLocalStorageName)

  if (!storedValue) {
    return null
  }

  try {
    const parsedValue = JSON.parse(storedValue)

    if (!path) {
      return parsedValue
    }

    return path.split('.').reduce((obj, keyPart) => {
      return obj && obj[keyPart] !== undefined ? obj[keyPart] : null
    }, parsedValue)
  } catch (e) {
    console.error('Zustand local storage reading error: ', e)
    return null
  }
}
